import * as React from 'react';

type IconSegmentoMarketplaceProps = React.SVGProps<SVGSVGElement>;

export const IconSegmentoMarketplace: React.FC<IconSegmentoMarketplaceProps> = (props) => (
	<svg
		width={29}
		height={24}
		viewBox="0 0 29 24"
		fill="#BBC2C7"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<g clipPath="url(#clip0_1646_23688)">
			<path d="M0.333252 1.125C0.333252 0.501562 0.847675 0 1.4871 0H3.6746C4.73229 0 5.66979 0.6 6.10729 1.5H25.8669C27.1313 1.5 28.0544 2.67188 27.7227 3.8625L25.7515 11.0016C25.3429 12.4734 23.9727 13.5 22.4102 13.5H8.53998L8.7996 14.8359C8.90537 15.3656 9.38133 15.75 9.93421 15.75H23.7948C24.4342 15.75 24.9486 16.2516 24.9486 16.875C24.9486 17.4984 24.4342 18 23.7948 18H9.93421C8.27075 18 6.84287 16.8469 6.53517 15.2578L4.05441 2.55469C4.02075 2.37656 3.8621 2.25 3.6746 2.25H1.4871C0.847675 2.25 0.333252 1.74844 0.333252 1.125ZM6.4871 21.75C6.4871 21.4545 6.54679 21.1619 6.66276 20.889C6.77873 20.616 6.94872 20.3679 7.163 20.159C7.37729 19.9501 7.63169 19.7843 7.91167 19.6713C8.19166 19.5582 8.49174 19.5 8.79479 19.5C9.09784 19.5 9.39792 19.5582 9.67791 19.6713C9.95789 19.7843 10.2123 19.9501 10.4266 20.159C10.6409 20.3679 10.8108 20.616 10.9268 20.889C11.0428 21.1619 11.1025 21.4545 11.1025 21.75C11.1025 22.0455 11.0428 22.3381 10.9268 22.611C10.8108 22.884 10.6409 23.1321 10.4266 23.341C10.2123 23.5499 9.95789 23.7157 9.67791 23.8287C9.39792 23.9418 9.09784 24 8.79479 24C8.49174 24 8.19166 23.9418 7.91167 23.8287C7.63169 23.7157 7.37729 23.5499 7.163 23.341C6.94872 23.1321 6.77873 22.884 6.66276 22.611C6.54679 22.3381 6.4871 22.0455 6.4871 21.75ZM22.6409 19.5C23.253 19.5 23.84 19.7371 24.2727 20.159C24.7055 20.581 24.9486 21.1533 24.9486 21.75C24.9486 22.3467 24.7055 22.919 24.2727 23.341C23.84 23.7629 23.253 24 22.6409 24C22.0289 24 21.4419 23.7629 21.0092 23.341C20.5764 22.919 20.3333 22.3467 20.3333 21.75C20.3333 21.1533 20.5764 20.581 21.0092 20.159C21.4419 19.7371 22.0289 19.5 22.6409 19.5Z" />
		</g>
		<defs>
			<clipPath id="clip0_1646_23688">
				<rect
					width="27.6923"
					height="24"
					fill="white"
					transform="translate(0.333252)"
				/>
			</clipPath>
		</defs>
	</svg>
);
